import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as formActions from '../../Redux/Actions/form';
import Header from '../Ui/Header';
import { useSortableData } from '../utils/sortableData';
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import {ContainerOuter} from '../Dashboard/styles';
import Warning from '../Ui/400';
import { clearSession } from '../utils/initiate';

const FormListing = ({history}) => {

    const [form, setForm] = useState([]);
    const [q, setQ] = useState("");
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();
    const [searchParam] = useState(["form", "department", "masterprocess", "process"]);

    useEffect(() => {
        formActions.getAllMappedForms().then(res => {
            let formList = [];
            res.data.map((form, index) => formList.push({'sno': index+1, ...form}));
            setForm(formList);
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    }, [dispatch, history]);

    const handleRedirectForm = (key, formID) => {
        formID ? history.push(`/${key}-form/${formID}`) : history.push(`/${key}`);
    }

    const search = (items) => {
        return items.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem]
                        .toString()
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }

    const {items, requestSort, sortConfig} = useSortableData(form);

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <>
            <ContainerOuter>
                <Header history={history} />
                <div className="d-flex align-items-center justify-content-between mt-6 mx-8 mb-0">
                    <input type="search" style={{width: '300px'}} className="form-control h-auto py-3 px-6" placeholder="Search for forms" value={q} onChange={(e) => setQ(e.target.value)} />
                    <p onClick={() => handleRedirectForm('create-form')} className="btn btn-success font-weight-bolder font-size-sm">Create Form</p>
                </div>
                <div className="tab-content m-6">
                    <div className="table-responsive">
                        <table className="table table-head-custom table-hover table-vertical-center table-head-bg">
                            <thead>
                                <tr className="text-left">
                                    <th className="cursor-pointer pl-7" style={{background: '#121180', width: '90px'}} onClick={() => requestSort('sno')}>
                                        <span className={(sortConfig && (sortConfig.key === 'sno')) ? "text-primary" : "text-white"}>S No {(sortConfig && (sortConfig.key === 'sno')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span>
                                    </th>
                                    <th className="cursor-pointer" style={{background: '#121180', width: '80px'}} onClick={() => requestSort('formId')}><span className={(sortConfig && (sortConfig.key === 'formId')) ? "text-primary" : "text-white"}>ID {(sortConfig && (sortConfig.key === 'formId')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    <th className="cursor-pointer" style={{background: '#121180', minWidth: '80px'}} onClick={() => requestSort('form')}><span  className={(sortConfig && (sortConfig.key === 'form')) ? "text-primary" : "text-white"}>Form {(sortConfig && (sortConfig.key === 'form')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    <th className="cursor-pointer" style={{background: '#121180', width: '180px'}} onClick={() => requestSort('department')}><span  className={(sortConfig && (sortConfig.key === 'department')) ? "text-primary" : "text-white"}>Department {(sortConfig && (sortConfig.key === 'department')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    <th className="cursor-pointer" style={{background: '#121180', width: '180px'}} onClick={() => requestSort('masterprocess')}><span  className={(sortConfig && (sortConfig.key === 'masterprocess')) ? "text-primary" : "text-white"}>Master Process {(sortConfig && (sortConfig.key === 'masterprocess')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    <th className="cursor-pointer" style={{background: '#121180', minWidth: '100px'}} onClick={() => requestSort('process')}><span  className={(sortConfig && (sortConfig.key === 'process')) ? "text-primary" : "text-white"}>Process {(sortConfig && (sortConfig.key === 'process')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                    <th style={{background: '#121180', width: '130px'}}><span className="text-white">Status</span></th>
                                    <th style={{background: '#121180', minWidth: '100px'}}><span className="text-white">Action</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {search(items).map(({sno, formId, form, department, masterprocess, process, formMapStatus}) => {
                                    return(
                                        <tr key={sno}>
                                            <td className="pl-7">
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{formId}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{form}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{department}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{masterprocess}</span>
                                            </td>
                                            <td>
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{process}</span>
                                            </td>
                                            <td style={{whiteSpace: 'nowrap'}}>
                                                <span className={"p-4 label label-outline-" + (formMapStatus ? 'success' : 'danger')} style={{borderRadius: '3px', width: 'auto'}}>{formMapStatus ? 'Mapped' : 'Not Mapped'}</span>
                                            </td>
                                            <td className="pr-0">
                                                <p onClick={() => handleRedirectForm('edit', formId)} className="btn btn-info font-weight-bolder font-size-sm m-0 mr-3 py-2">Edit Form</p>
                                                <p onClick={() => handleRedirectForm('preview', formId)} className="btn btn-primary font-weight-bolder font-size-sm m-0 mr-3 py-2">Preview</p>
                                                <p onClick={() => handleRedirectForm('form-mapping')} className="btn btn-warning font-weight-bolder font-size-sm m-0 mr-3 py-2">Form Mapping</p>
                                            </td>
                                        </tr>
                                    )})}
                            </tbody>
                        </table>
                        {(items.length === 0) && <p className="text-center mt-5 mb-5">No Data Available</p>}
                    </div>
                </div>
            </ContainerOuter>
        </>
    );
};

export default FormListing;